import { render, staticRenderFns } from "./cont_two.vue?vue&type=template&id=a015d2a8&scoped=true"
import script from "./cont_two.vue?vue&type=script&lang=js"
export * from "./cont_two.vue?vue&type=script&lang=js"
import style0 from "./cont_two.vue?vue&type=style&index=0&id=a015d2a8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a015d2a8",
  null
  
)

export default component.exports